import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  isLoginError : boolean = false;
  isOtpSent: boolean = false;
  isLocked: boolean = false;
  lockedUntil: string;
  OtpSentBy: string  = "";
  errorMessage: string = null;
  constructor(private userService : UserService,private router : Router) { }

  ngOnInit() {
  }

  public sendOTP(userName){
      //this.isOtpSent=true;
      this.OtpSentBy = "";
      this.lockedUntil = '';
      this.isLocked = false;
      this.userService.getUserOTP(userName).subscribe((data : any)=>{
        if (data!="")
        {

            if (data.toString().startsWith('LOCKED=')) {
              this.isOtpSent=false; 
              this.isLocked=true; 
              let s1: string[] =  data.toString().split('=');
              if (s1.length>1) {
                this.lockedUntil = s1[1];
              }
            } else {
              this.isOtpSent=true; 
              this.OtpSentBy = data;
            }
        }
      },
      (err : HttpErrorResponse)=>{
        this.isLoginError = true;
      });
  }
  

  public login(userName,password){
    this.errorMessage = null;
     this.userService.userAuthentication(userName,password).subscribe((data : any)=>{
      localStorage.setItem('userToken',data.access_token);
      //this.router.navigate(['main-page']);
      //this.router.navigateByUrl('/main-page');
      window.location.href = "/main-page";
    },
    (err : HttpErrorResponse)=>{ 
      this.isLoginError = true;
      if (err && err.error && err.error.error && err.error.error.startsWith('usilence=')) {
          this.errorMessage = err.error.error.replace('usilence=', '');
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/user/sign-in/sign-in.component.ts